import { TenantBrandingPalette } from '../interfaces/tenant.config.interface';

// Volet 2 — Preset PrimeNG dynamique par tenant.
//
// À partir de la palette de marque d'un tenant (7 nuances --color-brand-*),
// construit l'OBJET de surcharge passé à `updatePreset(...)` (@primeng/themes) au
// bootstrap (cf. app.ts). Fonction PURE et sans dépendance PrimeNG → couverte par
// une spec sans bootstrap ni DOM.
//
// La structure MIROITE `custom.preset.ts` (preset statique VGE) : mêmes clés,
// mêmes relations de nuances, de sorte que VGI/VGS obtiennent un comportement
// analogue à VGE mais dans LEUR couleur. VGE ne passe JAMAIS ici (aucune palette
// déclarée → app.ts n'appelle pas updatePreset) → le preset statique teal reste
// en vigueur, byte-identique.
//
// Mapping des nuances (identique à la logique paletteToCssVars) :
//   50 ← lowest · 100/200 ← lower · 300/400 ← low · 500 ← medium ·
//   600/700 ← hight · 800 ← highter · 900/950 ← hightest.
export function buildTenantPresetOverride(p: TenantBrandingPalette) {
  return {
    semantic: {
      primary: {
        50:  p.lowest,
        100: p.lower,
        200: p.lower,
        300: p.low,
        400: p.low,
        500: p.medium,
        600: p.hight,
        700: p.hight,
        800: p.highter,
        900: p.hightest,
        950: p.hightest,
      },
      colorScheme: {
        // Light : miroir de custom.preset.ts (color=low, hover=medium,
        // active=highter, contrast=hightest, inverse=lowest ; highlight
        // background=medium, focus=hight).
        light: {
          primary: {
            color: p.low,
            contrastColor: p.hightest,
            inverseColor: p.lowest,
            hoverColor: p.medium,
            activeColor: p.highter,
          },
          highlight: {
            background: p.medium,
            focusBackground: p.hight,
            color: '#ffffff',
            focusColor: '#ffffff',
          },
        },
        // Dark : miroir de custom.preset.ts (color=lower, active=low,
        // contrast/inverse=hightest ; highlight = translucide de `lower`).
        dark: {
          primary: {
            color: p.lower,
            contrastColor: p.hightest,
            inverseColor: p.hightest,
            hoverColor: p.lower,
            activeColor: p.low,
          },
          highlight: {
            background: `color-mix(in srgb, ${p.lower} 16%, transparent)`,
            focusBackground: `color-mix(in srgb, ${p.lower} 24%, transparent)`,
            color: 'rgba(255,255,255,.87)',
            focusColor: 'rgba(255,255,255,.87)',
          },
        },
      },
    },
  };
}
